/**
 * @generated SignedSource<<88b969ac55546f7bcc2d3ae2bf3f1a92>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type getOrderStatusLabel_transaction$data = {
  readonly currentBuyerTimelineStatus: {
    readonly label: string | null;
  } | null;
  readonly currentSellerTimelineStatus: {
    readonly label: string | null;
  } | null;
  readonly isCanceled: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"getBuyerEventHeader_transaction">;
  readonly " $fragmentType": "getOrderStatusLabel_transaction";
};
export type getOrderStatusLabel_transaction$key = {
  readonly " $data"?: getOrderStatusLabel_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"getOrderStatusLabel_transaction">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "getOrderStatusLabel_transaction"
};

(node as any).hash = "39c2c568bdc64e96990a977936659410";

export default node;
